import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgPlusCircle = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 14"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 1.313a5.687 5.687 0 1 0 0 11.374A5.687 5.687 0 0 0 7 1.313m0 10.5a4.812 4.812 0 1 1 0-9.624 4.812 4.812 0 0 1 0 9.624M9.625 7a.437.437 0 0 1-.437.438h-1.75v1.75a.437.437 0 1 1-.875 0v-1.75h-1.75a.437.437 0 1 1 0-.875h1.75v-1.75a.438.438 0 0 1 .875 0v1.75h1.75A.437.437 0 0 1 9.625 7"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPlusCircle);
export default ForwardRef;
